import * as React from 'react';

import Slider from './Slider';
import ItemInfo from '../../containers/CoverFlow/ItemInfo';
import { DriveItemInfoMap } from '../../containers/DriveItemList/reducer';
import usePreviousValue from '../../utils/customHooks/usePreviousValue';

interface CoverFlowProps {
	idsToDisplay: number[];
	folderId?: number;
	driveItems: DriveItemInfoMap;
	children: React.ReactNode;
	navigationItemsLength?: number;
	additionalItemsLength?: number;
	onFolderChange: () => void;
	onSlideChange: (newIndex: number) => void;
}

const INITIAL_SLIDE_INDEX = 0;

const CoverFlow = ({
	folderId,
	children,
	idsToDisplay,
	driveItems,
	onFolderChange,
	onSlideChange,
	navigationItemsLength = 0,
	additionalItemsLength = 0,
}: CoverFlowProps) => {
	const [currentSlideIndex, setCurrentSlideIndex] = React.useState(INITIAL_SLIDE_INDEX);
	const slidesLength = idsToDisplay.length + navigationItemsLength + additionalItemsLength;
	const prevSlidesLength = usePreviousValue(slidesLength);

	const handleSlideChange = (index: number) => {
		onSlideChange(index);
		setCurrentSlideIndex(index);
	};

	React.useEffect(() => {
		onFolderChange();
		setCurrentSlideIndex(INITIAL_SLIDE_INDEX);
	}, [folderId]);

	React.useEffect(() => {
		if (!prevSlidesLength) {
			return;
		}

		const isSlideAdded = slidesLength > prevSlidesLength;
		const isSlideRemoved = slidesLength < prevSlidesLength;

		if (isSlideAdded) {
			setCurrentSlideIndex(INITIAL_SLIDE_INDEX);
		}

		if (isSlideRemoved && currentSlideIndex === prevSlidesLength - 1) {
			setCurrentSlideIndex(currentSlideIndex - 1);
		}
	}, [slidesLength]);

	const navigationItemsIndexes = Array.from({ length: navigationItemsLength }, (v, i) => i);
	const isNavigationItem = navigationItemsIndexes.includes(currentSlideIndex);
	const additionalItemsIndexes = Array.from({ length: additionalItemsLength }, (v, i) => i + navigationItemsLength + idsToDisplay.length);
	const isAdditionalItem = additionalItemsIndexes.includes(currentSlideIndex);
	let currentDriveItem = driveItems[idsToDisplay[currentSlideIndex - navigationItemsLength]];
	let label = '';

	if (isNavigationItem && children) {
		currentDriveItem = children[currentSlideIndex].props;
		label = children[currentSlideIndex].props.itemLabel;
	}

	if (isAdditionalItem && children) {
		currentDriveItem = children[currentSlideIndex].props;
	}

	if (!currentDriveItem) {
		return null;
	}

	return (
		<>
			<Slider
				slidesLength={slidesLength}
				currentSlideIndex={currentSlideIndex}
				onSlideChange={handleSlideChange}
			>
				{children}
			</Slider>
			<ItemInfo
				currentDriveItem={currentDriveItem}
				isNavigationItem={isNavigationItem}
				label={label}
			/>
		</>
	);
};

export default CoverFlow;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CoverFlow/index.tsx